<template>
  <div class="container-page wide" style="max-width: 1406px">
    <div class="registry-mpk">
      <div class="registry-mpk__table-container js-table-arrow">
        <div class="registry-mpk__table table-container-base table-container-base--no-borders" v-if="page">
          <table>
            <thead>
              <tr>
                <th class="table-container-base__th column-68" v-if="canEdit || canDelete" scope="col"></th>
                <th class="table-container-base__th column-50 padding-left-md-14" scope="col">
                  <CheckboxInput id="allChkIsActive" :modelValue="allSelected" @update:modelValue="onSelectAllChange" />
                </th>
                <th
                  @click="changeSorting(0)"
                  :class="getClassSorting(0)"
                  class="table-container-base__th column-200 cursor-pointer"
                  scope="col"
                >
                  Заседание МПК
                </th>
                <!--Название поручения-->
                <th
                  @click="changeSorting(1)"
                  :class="getClassSorting(1)"
                  class="table-container-base__th column-160 cursor-pointer"
                  scope="col"
                >
                  Номер и дата поручения Правительства РФ
                </th>
                <th
                  @click="changeSorting(2)"
                  :class="getClassSorting(2)"
                  class="table-container-base__th column-100 cursor-pointer"
                  scope="col"
                >
                  № п/п
                </th>
                <th
                  @click="changeSorting(3)"
                  :class="getClassSorting(3)"
                  class="table-container-base__th column-240 cursor-pointer"
                  scope="col"
                >
                  Поручение
                </th>
                <th
                  @click="changeSorting(4)"
                  :class="getClassSorting(4)"
                  class="table-container-base__th column-300 cursor-pointer"
                  scope="col"
                >
                  Срок исполнения
                </th>
                <th
                  @click="changeSorting(5)"
                  :class="getClassSorting(5)"
                  class="table-container-base__th column-180 cursor-pointer"
                  scope="col"
                >
                  Исполнитель
                </th>
                <th
                  @click="changeSorting(6)"
                  :class="getClassSorting(6)"
                  class="table-container-base__th column-160 cursor-pointer"
                  scope="col"
                >
                  Статус
                </th>
                <th
                  @click="changeSorting(7)"
                  :class="getClassSorting(7)"
                  class="table-container-base__th column-300 cursor-pointer"
                  scope="col"
                >
                  Срок отчета в Минэкономразвития России
                </th>
                <th
                  @click="changeSorting(8)"
                  :class="getClassSorting(8)"
                  class="table-container-base__th column-180 cursor-pointer"
                  scope="col"
                >
                  Периодичность отчета
                </th>
              </tr>
              <tr class="table-container-base__filters">
                <th v-if="canEdit || canDelete" class="padding-left-md-14" scope="col"></th>
                <th scope="col"></th>
                <th class="filter" scope="col">
                  <SelectSingleComponentCheckbox
                    v-model="localFilter.mpkEventId"
                    mod="base"
                    placeholder="Выберите"
                    trackBy="text"
                    valueProp="id"
                    labelOptions="text"
                    :options="mpkEventList"
                    @update:modelValue="onFilterChange"
                    :canClear="false"
                    :disabled="!Number(filter.countryId)"
                  />
                </th>
                <th class="filter" scope="col">
                  <FilterInput
                    modClass="redesigned"
                    clearButtonModClass="redesigned"
                    placeholder="Введите"
                    v-model="localFilter.razdelProtocal"
                    @valueChangedDebounced="onFilterChange"
                  />
                </th>
                <th class="filter" scope="col">
                  <FilterInput
                    modClass="redesigned"
                    clearButtonModClass="redesigned"
                    placeholder="№"
                    v-model="localFilter.noPoint"
                    @valueChangedDebounced="onFilterChange"
                  />
                </th>
                <th class="filter" scope="col">
                  <FilterInput
                    modClass="redesigned"
                    clearButtonModClass="redesigned"
                    placeholder="Введите"
                    v-model="localFilter.brief"
                    @valueChangedDebounced="onFilterChange"
                  />
                </th>
                <th class="filter filter--half horizontally-date" scope="col">
                  <div class="filter__item">
                    <FilterInput
                      modClass="redesigned"
                      type="date"
                      v-model="localFilter.srokFrom"
                      @valueChangedDebounced="onFilterChange"
                    />
                  </div>
                  <div class="filter__item">
                    <FilterInput
                      modClass="redesigned"
                      type="date"
                      v-model="localFilter.srokTo"
                      @valueChangedDebounced="onFilterChange"
                    />
                  </div>
                </th>
                <th class="filter" scope="col">
                  <SelectSingleComponentCheckbox
                    v-model="localFilter.organizationId"
                    mod="base"
                    placeholder="Выберите"
                    trackBy="text"
                    valueProp="id"
                    labelOptions="text"
                    :options="organizationList"
                    @update:modelValue="onFilterChange"
                  />
                </th>

                <th class="filter" scope="col">
                  <SelectSingleComponentCheckbox
                    v-model="localFilter.mpkRegistryStatusId"
                    mod="base"
                    placeholder="Выберите"
                    trackBy="text"
                    valueProp="id"
                    labelOptions="text"
                    :options="statusList"
                    @update:modelValue="onFilterChange"
                  />
                </th>
                <th class="filter filter--half horizontally-date" scope="col">
                  <div class="filter__item">
                    <FilterInput
                      modClass="redesigned"
                      type="date"
                      v-model="localFilter.deadlineFrom"
                      @valueChangedDebounced="onFilterChange"
                    />
                  </div>
                  <div class="filter__item">
                    <FilterInput
                      modClass="redesigned"
                      type="date"
                      v-model="localFilter.deadlineTo"
                      @valueChangedDebounced="onFilterChange"
                    />
                  </div>
                </th>
                <th class="filter" scope="col">
                  <SelectSingleComponentCheckbox
                    v-model="localFilter.periodicity"
                    mod="base"
                    placeholder="Выберите"
                    trackBy="text"
                    valueProp="value"
                    labelOptions="text"
                    :options="periodOptions"
                    @update:modelValue="onFilterChange"
                  />
                </th>
              </tr>
            </thead>
            <tbody v-if="page.items && page.items?.length && !isLoading">
              <tr v-for="item in page.items" :key="item.id" @dblclick="viewCard(item.assignmentId)">
                <td class="column-68 padding-left-md-14" v-if="canEdit || canDelete">
                  <div class="wrap-icon">
                    <IconComponent
                      v-if="canEdit"
                      class="icon--full-svg"
                      @click="editCard(item.assignmentId)"
                      name="edit"
                    />
                    <IconComponent
                      v-if="canDelete"
                      class="icon--full-svg delete"
                      @click="deleteCard(item.id)"
                      name="delete-not-fill"
                    />
                  </div>
                </td>
                <td class="column-50">
                  <CheckboxInput
                    :id="item.id"
                    :modelValue="selectedIds.includes(item.id)"
                    @update:modelValue="toggleRowSelection(item.id, $event)"
                  />
                </td>
                <td class="column-200">{{ item.eventName }}</td>
                <td class="column-160">{{ item.assignmentRazdelProtocal }}</td>
                <!--Номер-->
                <td class="column-100">
                  {{ item.assignmentNoPoint }}
                </td>
                <td class="column-240">{{ item.assignmentBrief }}</td>
                <td class="column-260">
                  {{ formattedSrok(item) }}
                </td>
                <td class="column-180">{{ getExecutorDisplayName(item) }}</td>
                <td class="column-160" :class="{ draft: getStatusClass(item) }">
                  {{ getRegistryTableStatusName(item) }}
                </td>
                <td class="column-260">{{ $momentFormat(item.deadline, 'DD.MM.YYYY') }}</td>
                <td class="column-180">
                  {{ item.periodicityName }}
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" :colspan="canEdit || canDelete ? 10 : 9"><Loader class="loader"></Loader></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" :colspan="canEdit || canDelete ? 10 : 9">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <template v-if="page.pagesTotal > 1">
          <PaginationRedesigned
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            :loadingMore="isLoadingMore"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import FilterInput from '@/common/components/FilterInput.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import Loader from '@/components/Loader.vue';

  import { DUE_DATE_FOR_PERMANENT } from '@/modules/mpk/utils/constants';

  import { ORDER_PROJECT_STATUS, PERIOD_OPTIONS } from '../../constants/assignments';

  export default {
    name: 'AssignmentsTable',
    components: {
      FilterInput,
      CheckboxInput,
      IconComponent,
      PaginationRedesigned,
      Loader,
      SelectSingleComponentCheckbox,
    },
    emits: [
      'update:selectAll',
      'update:selectedIds',
      'changeSorting',
      'editCard',
      'deleteCard',
      'onPageChange',
      'filterChanged',
    ],
    props: {
      canEdit: {
        type: Boolean,
        required: true,
      },
      canDelete: {
        type: Boolean,
        default: false,
      },
      filter: {
        type: Object,
        required: true,
      },
      page: {
        type: Object,
        required: true,
      },
      mpkEventList: {
        type: Array,
        required: true,
      },
      organizationList: {
        type: Array,
        required: true,
      },
      statusList: {
        type: Array,
        required: true,
      },
      selectedIds: {
        type: Array,
        required: true,
      },
      isLoading: {
        type: Boolean,
        required: true,
      },
      isLoadingMore: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        localFilter: { ...this.filter },
        periodOptions: PERIOD_OPTIONS,
      };
    },
    watch: {
      filter: {
        handler(newFilter) {
          this.localFilter = { ...newFilter };
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      onSelectAllChange() {
        if (this.allSelected) {
          this.$emit('update:selectedIds', []);
          this.$emit('update:selectAll', false);
        } else {
          const allIds = (this.page?.items ?? []).map((item) => item.id);
          this.$emit('update:selectedIds', allIds);
          this.$emit('update:selectAll', true);
        }
      },
      toggleRowSelection(id, checked) {
        const next = checked ? [...this.selectedIds, id] : this.selectedIds.filter((existingId) => existingId !== id);
        this.$emit('update:selectedIds', next);
      },
      changeSorting(id) {
        this.$emit('changeSorting', id);
      },
      getClassSorting(id) {
        if (this.localFilter.sortColumn == id) {
          if (this.localFilter.sortOrder == 0) return 'table-header_descending';
          else if (this.localFilter.sortOrder == 1) return 'table-header_ascending';
        }
        return '';
      },
      editCard(assignmentId) {
        this.$emit('editCard', assignmentId);
      },
      deleteCard(assignmentId) {
        this.$emit('deleteCard', assignmentId);
      },
      viewCard(id) {
        this.$router.push({
          name: 'AssignmentCard',
          params: { id: id, action: 'edit' },
          state: { location: { countryId: this.filter.countryId, mpkEventId: this.filter.mpkEventId } },
        });
      },
      onPageChange(pageNumber, addToExist) {
        this.$emit('onPageChange', pageNumber, addToExist);
      },
      onFilterChange() {
        this.$emit('filterChanged', { ...this.localFilter });
      },
      formattedSrok(item) {
        return item.isPermanent ? DUE_DATE_FOR_PERMANENT : this.$momentFormat(item.assignmentSrok, 'DD.MM.YYYY');
      },
      getExecutorDisplayName(assignmentExecutorRow) {
        return (
          assignmentExecutorRow?.organizationName ||
          assignmentExecutorRow?.coexecutor ||
          assignmentExecutorRow?.coexecutorName ||
          ''
        );
      },
      getRegistryTableStatusName(item) {
        if (item.registryTableStatusName === ORDER_PROJECT_STATUS) {
          return 'Проект поручения. Направьте на исполнение';
        }

        return item.registryTableStatusName;
      },
      getStatusClass(item) {
        return item.registryTableStatusName === ORDER_PROJECT_STATUS;
      },
    },

    computed: {
      allSelected() {
        const total = this.page?.items?.length ?? 0;
        return total > 0 && this.selectedIds.length === total;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/table/table-base.scss';
  .registry-mpk {
    &__table {
      margin-bottom: 12px;
    }
  }

  .filter {
    &--half {
      display: flex;

      .filter__item {
        margin-right: 8px;
        height: 32px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .table-header_ascending::after {
    position: absolute;
    content: '';
    right: 8px;
    top: 4px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    border-bottom: 5px solid $blue-7;
  }

  .table-header_descending::after {
    position: absolute;
    content: '';
    right: 8px;
    top: 4px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    border-top: 5px solid $blue-7;
  }

  .table-container-base--no-borders thead .table-container-base__th {
    font-size: 14px;
    padding-right: 24px;
  }

  tbody > tr {
    td.draft {
      color: red;
    }

    &:hover {
      cursor: pointer;

      td {
        color: $blue-7;
      }
    }
  }
</style>
